import { defineComponent as _defineComponent } from 'vue';
import { BAlert } from "bootstrap-vue";
import { RouterLink } from "vue-router";
export default /*#__PURE__*/ _defineComponent({
    __name: 'RDMCredentialsInfo',
    props: {
        selectedRepository: { default: "the selected repository" }
    },
    setup(__props) {
        return { __sfc: true, BAlert, RouterLink };
    }
});
